/**
 * Warm the Portal lazy chunk after admin/team auth so navigating to /portal feels instant.
 * Same module path as React.lazy in App.tsx (Vite hashes the chunk URL consistently).
 */
let portalPrefetchStarted = false;

export function schedulePortalChunkPrefetch(): void {
  if (typeof window === "undefined" || portalPrefetchStarted) return;
  portalPrefetchStarted = true;

  const run = () => {
    void import("../pages/Portal").catch(() => {
      portalPrefetchStarted = false;
    });
  };

  const ric = window.requestIdleCallback;
  if (typeof ric === "function") {
    ric(() => run(), { timeout: 2500 });
  } else {
    window.setTimeout(run, 0);
  }
}
